import React, { useEffect, useState } from 'react';
import { Table, Button, message, Tabs } from 'antd';
import { getEncuestasAlimentacion, procesarEncuestasEDAH } from '../../services/configuracion_admin/procesar_edah';

const { TabPane } = Tabs;

const ProcesarEDAH = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [estadoActivo, setEstadoActivo] = useState('1');
    const [paginacion, setPaginacion] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    const fetchData = async (page = 1, pageSize = 10) => {
        try {
            setLoading(true);
            const encuestas = await getEncuestasAlimentacion();
            setData(encuestas);
            setPaginacion({
                current: page,
                pageSize: pageSize,
                total: encuestas.length
            });
        } catch (err) {
            message.error('Error al obtener las encuestas');
        } finally {
            setLoading(false);
        }
    };

    const handleProcesar = async () => {
        try {
            setLoading(true);
            const res = await procesarEncuestasEDAH();
            message.success(res.message || 'Encuestas procesadas exitosamente');
            await fetchData(); // Recargar tabla
        } catch (error) {
            message.error('Error al procesar encuestas');
        } finally {
            setLoading(false);
        }
    };

    const handleTableChange = (pagination) => {
        setPaginacion(pagination);
    };

    const handleTabChange = (key) => {
        setEstadoActivo(key);
        setPaginacion({ ...paginacion, current: 1 }); // resetear página
    };

  const columnas = [
    {
        title: 'Identificación',
        dataIndex: 'documento_identidad',
        key: 'documento_identidad'
    },
    {
        title: 'Nombre',
        dataIndex: 'nombre_encuestado',
        key: 'nombre_encuestado'
    },
    {
        title: 'Departamento',
        dataIndex: 'departamento',
        key: 'departamento'
    },
    {
        title: 'Municipio',
        dataIndex: 'municipio',
        key: 'municipio'
    },
    {
        title: 'Vereda',
        dataIndex: 'vereda',
        key: 'vereda'
    },
    {
        title: 'Puntaje Diversidad',
        dataIndex: 'puntaje_diversidad',
        key: 'puntaje_diversidad'
    },
    {
        title: 'Encuestador',
        dataIndex: 'nombre_encuestador',
        key: 'nombre_encuestador'
    },
];


    // Filtrar los datos por estado seleccionado
    const dataFiltrada = data.filter(item => String(item.estado) === estadoActivo);

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="container">
            <div className="row mb-2 d-flex align-items-center">
                <div className="col-md-8 linea_separador mb-2 d-flex align-items-center">
                    <div className="titulo_proyecto" style={{ flexBasis: '25%', flexGrow: 0 }}>
                        <p>PROYECTO UTF <br /> COL 160 COL</p>
                    </div>
                    <div className="objeto" style={{ flexBasis: '75%', flexGrow: 0 }}>
                        <p>
                            Implementar actividades de desarrollo económico, derecho humano a la alimentación y fortalecimiento de capacidades institucionales, comunitarias y organizacionales que aporten al cierre de brechas y la transformación de los territorios PDET
                        </p>
                    </div>
                </div>
                <div className="col-md-4 d-flex justify-content-center align-items-center flex-column">
                    <h2 className="text-center mb-2">Registros EDAH</h2>
                </div>
            </div>

            <Button
                type="primary"
                onClick={handleProcesar}
                loading={loading}
                style={{ marginBottom: '16px' }}
            >
                Procesar Encuestas
            </Button>

            <Tabs defaultActiveKey="1" onChange={handleTabChange}>
                <TabPane tab="Sin procesar" key="1" />
                <TabPane tab="Procesados" key="2" />
            </Tabs>

            <div className="participant-count-container">
                <h1 className="participant-count-title">
                    Total registros: <span className="participant-count-number">{dataFiltrada.length}</span>
                </h1>
            </div>

            <Table
                columns={columnas}
                dataSource={dataFiltrada}
                rowKey="id"
                pagination={paginacion}
                loading={loading}
                onChange={handleTableChange}
            />
        </div>
    );
};

export default ProcesarEDAH;
